export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11357.a79ad677.jpg";